const routes = Object.freeze({
  main: "/",
  pa_tool: "/pa-tool",
  sa_tool: "/sa-tool",
  lca_tool: "/lca-tool",
  pa_results: "/pa-tool/results",
  pa_tool_quiz_1: "/pa-tool/quiz-1",
  pa_tool_quiz_2: "/pa-tool/quiz-2",
  pa_tool_quiz_3: "/pa-tool/quiz-3",
  pa_tool_quiz_4: "/pa-tool/quiz-4",
  pa_tool_quiz_5: "/pa-tool/quiz-5",
  sa_tool_quiz_1: "/sa-tool/quiz-1",
  sa_tool_quiz_2: "/sa-tool/quiz-2",
  sa_tool_quiz_3: "/sa-tool/quiz-3",
  sa_tool_quiz_4: "/sa-tool/quiz-4",
  sa_tool_quiz_5: "/sa-tool/quiz-5",
  sa_results: "/sa-tool/sa-results",
  lca_tool_quiz_1: "/lca-tool/quiz-1",
  lca_tool_quiz_2: "/lca-tool/quiz-2",
  lca_tool_quiz_3: "/lca-tool/quiz-3",
  lca_tool_quiz_4: "/lca-tool/quiz-4",
  lca_tool_quiz_5: "/lca-tool/quiz-5",
  lca_tool_quiz_6: "/lca-tool/quiz-6",
  lca_tool_quiz_7: "/lca-tool/quiz-7",
  lca_results: "/lca-tool/lca-results",
  account: "/account",
  contacts: "/contacts",
  faq: "/faq",
})

export default routes